export default __webpack_public_path__ + "static/media/craneo.ce3bd241.png";